// The menu's order button look (menu.order_button_style), shared by OrderButton.vue and the settings
// preview. Every option is optional: a missing one means the original button (a small outlined square
// with "+" in the item text colour), so menus that never set a style look exactly as before.

export const ORDER_BUTTON_OPTIONS = {
  shape: [{ value: 'square', label: 'Square' }, { value: 'rounded', label: 'Rounded' }, { value: 'circle', label: 'Circle' }],
  fill: [{ value: 'outline', label: 'Outline' }, { value: 'filled', label: 'Filled' }],
  size: [{ value: 'small', label: 'Small' }, { value: 'medium', label: 'Medium' }, { value: 'large', label: 'Large' }],
  label: [{ value: 'icon', label: '+ icon' }, { value: 'text', label: 'Text' }]
}

const DEFAULTS = { shape: 'square', fill: 'outline', size: 'small', label: 'icon', colour: null, text_colour: '#ffffff', text: {} }
const SIZES = { small: { box: 20, font: 13 }, medium: { box: 28, font: 15 }, large: { box: 36, font: 17 } }
const RADII = { square: '3px', rounded: '8px', circle: '999px' }

export function normaliseOrderButtonStyle(style) {
  const merged = { ...DEFAULTS, ...(style || {}) }
  merged.text = { ...(style && style.text) }
  return merged
}

// Inline styles for a button. fallbackColour is the colour the original button used (the item text colour).
// wide: a text button, which grows to fit its label instead of staying square.
export function orderButtonCss(style, fallbackColour, wide = false) {
  const s = normaliseOrderButtonStyle(style)
  const size = SIZES[s.size] || SIZES.small
  const colour = s.colour || fallbackColour || '#000000'
  const filled = s.fill === 'filled'
  return {
    borderColor: colour,
    backgroundColor: filled ? colour : 'transparent',
    color: filled ? (s.text_colour || '#ffffff') : colour,
    borderRadius: RADII[s.shape] || RADII.square,
    height: `${size.box}px`,
    minWidth: `${size.box}px`,
    width: wide ? 'auto' : `${size.box}px`,
    padding: wide ? `0px ${Math.round(size.box / 2)}px` : '0px',
    fontSize: `${size.font}px`,
    fontWeight: wide ? 600 : null,
    boxSizing: 'border-box',
    whiteSpace: 'nowrap'
  }
}

// The text-button label in this language: the menu's own wording if set, else "Add" in that language.
export function orderButtonLabel(style, language, translations) {
  const s = normaliseOrderButtonStyle(style)
  const custom = s.text[language] || null
  const fallback = translations && translations.add_to_order ? translations.add_to_order[language] : 'Add'
  return custom || fallback || 'Add'
}
